// extracted by mini-css-extract-plugin
export default {"headerNav":"MerchantListComponent_headerNav__15QVd"};